'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const tslib = require('tslib');
const isSvgComponent = require('./is-svg-component.js');
const useRender = require('../use-render.js');
const configMotion = require('../../svg/config-motion.js');
const configMotion$1 = require('../../html/config-motion.js');

function createDomMotionConfig(defaultFeatures, Component, forwardMotionProps) {
  var baseConfig = isSvgComponent.isSVGComponent(Component) ? configMotion.svgMotionConfig : configMotion$1.htmlMotionConfig;
  return tslib.__assign(tslib.__assign({}, baseConfig), {
    defaultFeatures: defaultFeatures,
    useRender: useRender.createUseRender(Component, forwardMotionProps)
  });
}

exports.createDomMotionConfig = createDomMotionConfig;
